
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicabs() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Cabs',
        heading: 'Platinum24 Cabs: Pune to Mumbai Cabs',
        headingDescription: 'Platinum24 Cabs provides reliable Pune to Mumbai Cabs with clean, comfortable vehicles and experienced drivers. Whether you’re traveling for business, leisure, or airport transfers, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth ride on this busy route. We offer flexible one-way and round-trip options, affordable fares, and punctual service for a hassle-free journey. With 24/7 availability, GPS-enabled cars, and customer-focused support, Platinum24 Cabs makes your Pune to Mumbai travel safe, timely, and convenient every time',

        top: 'Top Places to Visit in Mumbai  with Platinum24 Cabs',

        "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Designed in Indo-Saracenic style, it was constructed to commemorate the visit of King George V and Queen Mary. Today, it is a bustling tourist hub with ferries to Elephanta Caves. The backdrop of the Taj Mahal Palace Hotel adds to its grandeur. At night, the illuminated monument creates a spectacular sight. Gateway of India is Mumbai’s proud symbol of history and culture."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km-long promenade along the Arabian Sea. Its arc-shaped boulevard glitters like a necklace when lit at night. Locals and tourists flock here for evening walks, jogging, or simply watching the sunset. During monsoon, the roaring waves make it dramatic and thrilling. The stretch connects Nariman Point to Chowpatty Beach. Marine Drive is Mumbai’s most loved seaside escape."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, a UNESCO World Heritage Site, are located on Elephanta Island, 11 km from Mumbai. These 5th–8th century rock-cut caves are dedicated to Lord Shiva. The magnificent Trimurti sculpture is the highlight of the site. Visitors reach the caves via ferry rides from the Gateway of India. Surrounded by lush greenery and sea views, the caves blend history with natural charm. Elephanta Caves are Mumbai’s heritage jewel of art and devotion."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of Mumbai’s busiest railway stations. Built in 1887, its Gothic Revival architecture includes domes, turrets, stained glass, and detailed carvings. The station remains the heart of Mumbai’s suburban and long-distance train network. At night, its colorful lighting makes it a stunning attraction. Tourists admire its unique blend of British and Indian design. CSMT is Mumbai’s living monument of heritage and connectivity."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, stretching for several kilometers. It is known for its golden sands, buzzing crowds, and delicious street food. Pav bhaji, bhel puri, and ice gola are must-try treats here. The beach is also popular because of its proximity to Bollywood celebrities’ residences. Sunsets at Juhu are magical and draw large crowds. Juhu Beach is Mumbai’s vibrant seaside destination of leisure and flavor."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, the temple’s idol with a right-turned trunk is considered highly auspicious. Devotees, including Bollywood stars and politicians, throng the temple daily. Tuesdays see especially large crowds for darshan. The temple also supports various social and charitable activities. Siddhivinayak Temple is Mumbai’s divine and spiritual powerhouse."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in 1431, is a beautiful mosque and tomb located on a small islet in the Arabian Sea. It houses the shrine of Pir Haji Ali Shah Bukhari, a revered saint. A narrow causeway connects it to the mainland, accessible only during low tide. The white marble structure glows beautifully against the sea. Pilgrims of all faiths visit for blessings. Haji Ali Dargah is Mumbai’s symbol of spirituality and harmony."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling shopping and cultural street. Tourists enjoy exploring stalls selling jewelry, clothes, handicrafts, and antiques. It is also home to iconic cafés like Leopold Café and Café Mondegar. The area is lined with colonial-era buildings adding historic charm. Bargain hunters and culture lovers find it irresistible. Colaba Causeway is Mumbai’s ultimate hub for shopping, heritage, and vibrant city life."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty, also known as Chowpatty Beach, is a popular cultural hotspot in South Mumbai. It is famous for Ganesh Visarjan immersions where thousands gather during festivals. Families enjoy evenings here with street food like pav bhaji, kulfi, and gola. Fairs and cultural events often take place along the beach. The Arabian Sea backdrop adds scenic beauty. Girgaon Chowpatty is Mumbai’s seaside celebration of devotion and community."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, spread across 100 sq km, is one of the world’s largest parks within a city. It is home to leopards, deer, monkeys, and more than 250 bird species. The park also houses the Kanheri Caves, a group of ancient Buddhist rock-cut structures. Activities like safaris, boating, and trekking make it popular with families and adventurers. Its greenery offers a refreshing escape from city life. Sanjay Gandhi National Park is Mumbai’s natural oasis of wildlife and heritage."
  }
],



      "services": [
    {
      "name": "Pune to Mumbai Cab Service",
      "description": "Reliable and comfortable Pune to Mumbai cab service designed to make your intercity travel smooth and hassle-free. Our professional drivers ensure timely pickups and safe journeys, with a variety of vehicle options tailored to your group size and budget."
    },
    {
      "name": "Affordable Cabs Pune to Mumbai",
      "description": "Budget-friendly cab options for travel from Pune to Mumbai, offering competitive rates without compromising on comfort or safety. Ideal for frequent commuters and travelers seeking economical and dependable transportation between these cities."
    },
    {
      "name": "Luxury Cabs Pune to Mumbai",
      "description": "Travel in premium style with our luxury cabs from Pune to Mumbai. Equipped with plush seating, climate control, and modern amenities, our high-end vehicles provide a sophisticated and relaxing ride for business travelers, VIPs, and special occasions."
    },
    {
      "name": "Pune to Mumbai cheapest cab",
      "description": "Find the cheapest cab service from Pune to Mumbai without sacrificing quality or reliability. Our affordable options come with transparent pricing, well-maintained vehicles, and professional drivers, making your journey cost-effective and comfortable."
    },
    {
      "name": "Pune Mumbai Taxi Service",
      "description": "Comprehensive taxi services connecting Pune and Mumbai with punctual, safe, and customer-friendly rides. Choose from sedans, SUVs, and more, with flexible booking options and excellent customer support to meet your travel needs."
    },
    {
      "name": "Pune to Mumbai Airport Cabs",
      "description": "Specialized cab service for Pune to Mumbai airport transfers, ensuring you arrive on time for your flights in clean, comfortable vehicles. Our experienced drivers assist with luggage and offer door-to-door service for stress-free travel."
    },
    {
      "name": "Pune to Mumbai Outstation Cabs",
      "description": "Reliable outstation cab service from Pune to Mumbai designed for longer journeys with comfort and safety in mind. Enjoy flexible scheduling, well-maintained vehicles, and professional chauffeurs for your intercity travel needs."
    },
    {
      "name": "Pune to Mumbai Cab Booking Online",
      "description": "Convenient online cab booking for Pune to Mumbai travel, allowing you to secure your ride quickly with instant confirmations and multiple payment options. Plan your trip hassle-free with transparent pricing and real-time updates."
    },
    {
      "name": "Pune Mumbai Express Taxi",
      "description": "Fast and efficient Pune to Mumbai express taxi service for travelers in a hurry. Experience prompt pickups, direct routes, and professional drivers ensuring you reach your destination quickly and safely."
    },
    {
      "name": "Pune to Mumbai Private Cabs",
      "description": "Enjoy privacy and personalized service with Pune to Mumbai private cabs, perfect for individuals, families, or business travelers seeking exclusive rides. Our vehicles are clean, comfortable, and driven by courteous professionals."
    },
    {
      "name": "Pune Mumbai One-Way Taxi",
      "description": "Flexible one-way taxi service between Pune and Mumbai, offering convenient drop-offs without requiring a return journey booking. Ideal for travelers with one-way trips who want affordability combined with comfort and reliability."
    },
    {
      "name": "Pune to Mumbai Round Trip Cabs",
      "description": "Book round trip cabs from Pune to Mumbai with ease, perfect for business trips, weekend getaways, or special events. Enjoy seamless scheduling, fixed pricing, and dedicated drivers for your round journey needs."
    },
    {
      "name": "Pune to Mumbai cabs",
      "description": "Trusted cabs for travel between Pune and Mumbai, offering a wide range of vehicles to suit all budgets and preferences. Our services prioritize safety, punctuality, and customer satisfaction for every trip."
    },
    {
      "name": "Pune to Mumbai Airport cab",
      "description": "Dedicated Pune to Mumbai airport cab service providing timely transfers with experienced drivers and comfortable vehicles. We ensure a smooth journey to catch your flight without any stress."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Reliable Pune Mumbai cab service catering to daily commuters, tourists, and business travelers. Our fleet includes economy and luxury cars to match your travel style and requirements."
    },
    {
      "name": "Pune to Mumbai Taxi",
      "description": "Professional taxi service from Pune to Mumbai with focus on safety, punctuality, and customer comfort. Our friendly drivers and well-maintained cars make long-distance travel easy and enjoyable."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Cab Service", "Affordable Cabs Pune to Mumbai"],
    ["Luxury Cabs Pune to Mumbai", "Pune to Mumbai cheapest cab"],
    ["Pune Mumbai Taxi Service", "Pune to Mumbai Airport Cabs"],
    ["Pune to Mumbai Outstation Cabs", "Pune to Mumbai Cab Booking Online"],
    ["Pune Mumbai Express Taxi", "Pune to Mumbai Private Cabs"],
    ["Pune Mumbai One-Way Taxi", "Pune to Mumbai Round Trip Cabs"],
    ["Pune to Mumbai cabs", "Pune to Mumbai Airport cab"],
    ["Pune Mumbai Cab", "Pune to Mumbai Taxi"]
  ],


   "whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Mumbai Cabs for Comfortable Travel",
        "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly and reliable cab services for your Pune to Mumbai journey."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Long-Distance Travel",
        "WhyChoosedescription": "Our cabs provide ample legroom and comfort, making your trip from Pune to Mumbai relaxing."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
        "WhyChoosedescription": "We prioritize your safety with regularly serviced and sanitized vehicles before every trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mumbai Route",
        "WhyChoosedescription": "Our professional drivers know the best routes and traffic patterns for a smooth and timely journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
        "WhyChoosedescription": "Choose from one-way, round-trip, or custom packages to suit your Pune to Mumbai travel plans."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "Enjoy clear, all-inclusive pricing that covers fuel, tolls, and driver allowances for your peace of mind."
    },
    {
        "WhyChooseheading": "Ideal for Business Trips, Family Visits, and Group Travel",
        "WhyChoosedescription": "Our Pune to Mumbai cabs cater to various travel needs, whether personal or corporate."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, itinerary changes, and special requests."
    }
]













    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Mumbai?',
        answer: 'Yes, Platinum24 Cabs offers comfortable and reliable cab services for travel between Pune and Mumbai.',
    },
    {
        question: 'How can I book a Pune to Mumbai cab with Platinum24 Cabs?',
        answer: 'You can book your Pune to Mumbai cab easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Mumbai trips?',
        answer: 'We provide a variety of vehicles including sedans, SUVs, and luxury cars to suit your comfort and budget.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Mumbai?',
        answer: 'Yes, all our drivers are professional, experienced in long-distance routes, and ensure a safe journey.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Mumbai?',
        answer: 'Absolutely! We offer round-trip cab bookings with flexible pickup and drop timings as per your itinerary.',
    },
    {
        question: 'What is included in the fare for Pune to Mumbai cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Is there an option to customize pickup and drop locations on the Pune to Mumbai route?',
        answer: 'Yes, you can customize your pickup and drop-off points anywhere along the Pune-Mumbai corridor.',
    },
    {
        question: 'Are there any safety measures for Pune to Mumbai cab rides?',
        answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety protocols to ensure your wellbeing.',
    },
    {
        question: 'Can I hire a cab for multiple days for Pune to Mumbai travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages suitable for your travel plans between Pune and Mumbai.',
    },
    {
        question: 'Do Platinum24 Cabs provide corporate bookings for Pune to Mumbai travel?',
        answer: 'Yes, we provide customized corporate travel solutions including priority support and billing options for Pune to Mumbai routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Desai',
        feedback: 'I booked a cab from Pune to Mumbai with Platinum24 Cabs. The journey was smooth, and the driver was very professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Shah',
        feedback: 'Platinum24 Cabs made my Pune to Mumbai trip comfortable and hassle-free. Highly recommend their service!',
        rating: 5,
    },
];






























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToMumbaiCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-mumbai-cab.jpg",
  "description": "Book reliable Pune to Mumbai cabs with Platinum24 Cabs. Choose from affordable, luxury, and one-way or round-trip taxi services. Instant booking, verified drivers, and 24/7 customer support.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "47850",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-mumbai-cabs"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Cabs | One-Way & Round Trip Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable Pune to Mumbai cabs with Platinum24 Cabs. Choose from affordable, luxury, and one-way or round-trip taxi services. Instant booking, verified drivers, and 24/7 customer support."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToMumbaiCabsSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaicabs;